export const removePhoneMask = (value: string) => {
  return value.replace(/\D/g, ``);
};

const fixedPhoneMask = (phone: string) =>
  phone.replace(/(\d{2})(\d)/, `($1) $2`).replace(/(\d{4})(\d)/, `$1-$2`);

const cellphoneMask = (phone: string) =>
  phone
    .replace(/(\d{2})(\d)/, `($1) $2`)
    .replace(/(\d{5})(\d)/, `$1-$2`)
    .replace(/(-\d{4})\d+?$/, `$1`);

export const maskPhone = (phone: string) => {
  const sanitazedPhone = removePhoneMask(phone);

  if (sanitazedPhone.length < 11) {
    return fixedPhoneMask(sanitazedPhone);
  }

  return cellphoneMask(sanitazedPhone);
};
